module.exports = __webpack_public_path__ + "media/images/icon__infoBox-0cb6b3a0dde6c809677c1d18ca321b9f.png";